import * as React from 'react'
import { LeftProgressNode } from './LeftProgressNode'
import { MiddleProgressNode } from './MiddleProgressNode'
import { RightProgressNode } from './RightProgressNode'
import { SingleProgressNode } from './SingleProgressNode'
import { EndProgressItemProps } from './typings'

export interface Props extends EndProgressItemProps {
  variant: 'left' | 'middle' | 'right' | 'single'
}

export const ProgressWidgetSvg: React.FC<Props> = (props: Props) => {
  const component = (): JSX.Element => {
    switch (props.variant) {
      case 'left':
        return <LeftProgressNode {...props} />
      case 'middle':
        return <MiddleProgressNode {...props} />
      case 'right':
        return <RightProgressNode {...props} />
      case 'single':
        return <SingleProgressNode {...props} />
    }
  }

  return <>{component()}</>
}

ProgressWidgetSvg.displayName = 'BreadCrumb'
